// @flow
import { Component } from "react";

import ErrorBoundaryFallback from "./ErrorBoundaryFallback";

import type { ComponentType, Node } from "react";
import type { Props as FallbackProps } from "./ErrorBoundaryFallback";
export type Props = {
  +children: ?Node,
  +FallbackComponent: ComponentType<FallbackProps>,
};

type ErrorInfo = {
  componentStack: string,
  ...
};

type State = {
  error: ?Error,
  errorInfo: ?ErrorInfo,
};

/**
 */
class ErrorBoundary extends Component<Props, State> {
  static defaultProps: { FallbackComponent: ComponentType<FallbackProps> } = {
    FallbackComponent: ErrorBoundaryFallback,
  };

  state: State = {
    error: null,
    errorInfo: null,
  };

  /**
   */
  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    this.setState({ error, errorInfo });
  }

  /**
   */
  render(): Node {
    const { children, FallbackComponent } = this.props; // NOSONAR
    const { error, errorInfo } = this.state;

    if (error != null) {
      return (
        <FallbackComponent
          componentStack={errorInfo ? errorInfo.componentStack : ""}
          error={error}
        />
      );
    }

    return children ?? null;
  }
}
ErrorBoundary.displayName = "BI.ErrorBoundary";

export default ErrorBoundary;
